import { ModelSagres } from "../model-sagres"
import { ArquivoConvenio } from "./arquivo-convenio"
import { ParticipanteConvenio } from "./participante-convenio"

export class Convenio extends ModelSagres {

    IdConvenio: number
    IdUnidGestora: number
    NrConvenio: number
    NrAnoConvenio: number
    IdTipoConvenio: number
    //FlNaturezaEconomica: null,
    DtCelebracao: Date
    DtPublicacao: Date
    DtInicioVigencia: Date
    DtFimVigencia: Date
    DeObjetoConvenio: string
    VlConvenio: number
    NmVeiculoPublConv: string
    CdBancoConv: string
    CdAgenciaConv: string
    NrContaConv: string
    DtCancelamentoConv: Date
    DeMotivoCancelConv: string | null
    NmUsuarioUltimaAlteracao: string
    DtUltimaAlteracao: Date
    //IdTipoConvenioNavigation: null
    //AditivoConvenio: []
    ArquivoConvenio: ArquivoConvenio[]
    ParticipanteConvenio: ParticipanteConvenio[]
    NmAutorEmenda: string

    tratarDadosDaAPI(): void {
        if (this.DtInicioVigencia) {
            this.DtInicioVigencia = new Date(this.DtInicioVigencia)
        }
        if (this.DtFimVigencia) {
            this.DtFimVigencia = new Date(this.DtFimVigencia)
        }
        if (this.DtCelebracao) {
            this.DtCelebracao = new Date(this.DtCelebracao)
        }

        if (this.DtCancelamentoConv) {
            this.DtCancelamentoConv = new Date(this.DtCancelamentoConv)
        }
        if (this.DtPublicacao) {
            this.DtPublicacao = new Date(this.DtPublicacao)
        }
        if (this.DtUltimaAlteracao) {
            this.DtUltimaAlteracao = new Date(this.DtUltimaAlteracao)
        }
    }

    toFormData(): FormData {
        const data = new FormData()
        data.append('NumeroConvenio', this.NrConvenio.toString())
        data.append('AnoConvenio', this.NrAnoConvenio.toString())
        data.append('IdTipoConvenio', this.IdTipoConvenio.toString())
        data.append('DeObjetoConvenio', this.DeObjetoConvenio)
        data.append('DtInicioVigencia', this.DtInicioVigencia.toISOString())
        data.append('DtFimVigencia', this.DtFimVigencia.toISOString())
        data.append('DtPublicacao', this.DtPublicacao.toISOString())
        data.append('DtCelebracao', this.DtCelebracao.toISOString())
        data.append('NmVeiculoPublicacao', this.NmVeiculoPublConv)
        if(this.CdBancoConv !== null && this.CdBancoConv !== undefined)
            data.append('CodigoBanco', this.CdBancoConv)
        if(this.CdAgenciaConv !== null  && this.CdAgenciaConv !== undefined)
            data.append('CodigoAgencia', this.CdAgenciaConv)
        if(this.NrContaConv !== null  && this.NrContaConv !== undefined)
            data.append('NumeroConta', this.NrContaConv)
        if(this.NmAutorEmenda !== null  && this.NmAutorEmenda !== undefined)
            data.append('NmAutorEmenda', this.NmAutorEmenda)
        return data;
    }
}